import { render, staticRenderFns } from "./FirmsReportEmployeeSearchModal.vue?vue&type=template&id=9b4544a6&scoped=true"
import script from "./FirmsReportEmployeeSearchModal.vue?vue&type=script&lang=ts"
export * from "./FirmsReportEmployeeSearchModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4544a6",
  null
  
)

export default component.exports